<template>
  <div class="change-pwd-container">
    <a-card title="更改密码" class="change-pwd-card">
      <a-form
          name="change-pwd"
          :model="formState"
          @finish="onFinish"
          @finishFailed="onFinishFailed"
      >
        <a-form-item
            name="password"
            :rules="[{ required: true, message: '请输入原密码!' }]"
        >
          <a-input-password v-model:value="formState.password" placeholder="原密码" />
        </a-form-item>

        <a-form-item
          name="newPassword"
          :rules="[{required:true,message:'请输入新密码'}]"
          >
          <a-input-password v-model:value="formState.newPassword" placeholder="新密码"/>
        </a-form-item>

        <a-form-item
            name="confirm"
            :rules="[
              { required: true, message:'请再次输入密码！'},
              { validator: validateConfirm }
            ]"
        >
          <a-input-password v-model:value="formState.confirm" placeholder="确认密码" />
        </a-form-item>


        <a-form-item>
          <router-link to="/" id="link-container">返回地图...</router-link>
          <a-button type="primary" html-type="submit" block>
            确认修改
          </a-button>


        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script setup>
import request from '@/utils/request'
import { ref,reactive } from 'vue'
import {message} from "ant-design-vue";
import router from "@/router/index.js";

const formState=reactive({
  password:"",
  newPassword:"",
  confirm:"",
});
const validateConfirm = (_, value) => {
  if (!value) {
    return Promise.reject()
  }
  if (value !== formState.newPassword) {
    return Promise.reject("两次输入的密码不一致")
  }
  return Promise.resolve()
}



const onFinish = async (values) => {
  try{
    await request.put("/auth/changePwd",null,{
      params:{
        password:formState.password,
        newPassword:formState.newPassword
      }
    })
    message.success("修改成功！")
    localStorage.removeItem("token")
    await router.replace("/login");
  }catch (e)
  {
    message.error(e.message || "修改失败")
  }
}

const onFinishFailed = () => {
  message.error("请填写完整信息！")
}

</script>

<style scoped>
.change-pwd-container {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(120deg, #1890ff, #87cefa);
}

.change-pwd-card {
  width: 350px;
  border-radius: 10px;
}
#link-container{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>